// 承載router-view的components
const Start = resolve => {
  import('components/start/start').then(module => {
    resolve(module);
  });
};

export default {
  path: '/car',
  component: Start,
  children: [
    {
      path: 'query',
      name: '用车查询',
      component: resolve => require(['pages/car/query/query.vue'], resolve),
    },
    {
      path: 'orderDetails',
      name: '用车订单详情',
      component: resolve => require(['pages/car/order/order-details/order-details.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/home',
    },
  ]
}
